import 'moment/min/locales';
import { Icon } from 'components/icon';

import { Button, ITableStructureItem, Table } from 'modules';
import moment from 'moment';
import React, { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as xlsx from 'xlsx';

import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../../components/table-filter-inputs';
import { getLocaleKey } from '../../../languages';
import { AdminService } from '../../../services/admin';
import { useSelector } from '../../../store';
import transferWrapper from '../components/wrapper';
import { DEFAULT_PAGE } from 'configs';

const TransferList = transferWrapper(
  memo(() => {
    const navigate = useNavigate();
    const optionsTimeFilter = [
      { label: 'This Day', value: 'day' },
      { label: 'This Week', value: 'week' },
      { label: 'This Month', value: 'month' },
      { label: 'Custom', value: 'custom' },
    ];

    const [params, setParams] = useState<any>();
    const [currentData, setCurrentData] = useState<any>(null);
    const [editData, setEditData] = useState(null);
    const [freezeDataId, setFreezeDataId] = useState<number | null>(null);
    const [forceUpdateTable, setForceUpdateTable] = useState<boolean>();
    const user = useSelector((state) => state.user);
    const [isShowRangeTime, setIsShowRangeTime] = useState<boolean>(false);
    const [valuePhoneFilter, setValuePhoneFilter] = useState<any>();
    const [valueDisplayNameFilter, setValueDisplayNameFilter] = useState<any>();
    const [valueTypeFilter, setValueTypeFilter] = useState<any>();
    const [valueTimeFilter, setValueTimeFilter] = useState<any>();

    const [totalTransferAmount, setTotalTransferAmount] = useState<any>(0);

    const structure: ITableStructureItem[] = [
      // {
      //     name: "UserId",
      //     key: "userId"
      // },
      {
        name: 'CREATED DATE',
        key: 'createdAt',
        render: (item) =>
          item?.createdAt != null
            ? moment(item?.createdAt)
                .locale(getLocaleKey())
                .format('L HH:mm:ss')
            : 'N/A',
      },
      {
        name: 'TRANSFER TO',
        key: 'transferTo',
        render: (item) => (
          <div className='user'>
            <div className='user__avatar'>
              <img
                className={`user__avatar__image ${item?.user?.avatar == null ? 'image-error' : ''}`}
                src={item?.user?.avatar ?? '/assets/images/no-image.jpg'}
                onError={(event: any) => {
                  if (!event.target.classList.contains('image-error')) {
                    event.target.classList.add('image-error');
                  }
                  event.target.src = '/assets/images/no-image.jpg';
                }}
                alt=''
                onClick={(event: any) => {
                  if (event.target.classList.contains('image-error')) return;
                  window.open(item?.user?.avatar, '_blank');
                }}
              />
            </div>
            <div className='user__info'>
              <div className='user__info__phone'>
                {item?.user?.phoneNumber ?? 'N/A'}
              </div>
              <div className='user__info__name'>
                {item?.user?.fullName ?? 'N/A'}
              </div>
            </div>
          </div>
        ),
      },
      {
        name: 'AMOUNT',
        key: 'value',
        render: (item) =>
          item?.value != null
            ? new Intl.NumberFormat('en').format(item?.value)
            : 'N/A',
      },

      {
        name: 'DESCRIPTION',
        key: 'description',
        render: (item: any) =>
          (item?.description ?? '') !== '' ? item?.description : 'N/A',
      },
      // {
      //     name: "Last Name",
      //     key: "lastName",
      // },
      // {
      //     name: "Phone",
      //     key: "phoneNumber",
      // },

      // {
      //     name: "Status",
      //     key: "status",
      //     render: (item) => <span className={`status status--${item?.status?.toLowerCase()}`}>{translate(item?.status).toUpperCase()}</span>,
      //     sort: {
      //         descreaseValue: "desc",
      //         increaseValue: "",
      //     },
      // },
    ];

    const handleExportExcel = async () => {
      const response = await AdminService.getListTransactions({
        ...params,
        page: DEFAULT_PAGE,
        pageSize: currentData?.count,
      });

      const fileHead = structure.map((v) => v.name);
      const dataExport = [
        fileHead,
        ...response.data.map((item: any) =>
          structure.map((column, index) => {
            if (!column.key) return '';
            if (column.key === 'transferTo') return item?.user?.phoneNumber;
            return item[column.key];
          }),
        ),
      ];

      const ws = xlsx.utils.aoa_to_sheet(dataExport);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'SheetJS');

      const now = new Date();
      xlsx.writeFile(
        wb,
        `Transfer List ${now.toLocaleDateString().replace(/\//g, '-')} ${now
          .toLocaleTimeString()
          .replace(/:/g, '-')}.xlsx`,
        { type: 'binary' },
      );
    };

    return (
      <div className='transfer-list'>
        <div className='button-container'>
          <Button
            disabled={!currentData}
            className='mb20'
            label='Export excel'
            buttonType='success'
            onClick={handleExportExcel}
          />
          <div className='infor-container'>
            <div className='total-transfer-amount'>
              <div className='total-transfer-amount__icon'>
                <Icon.TotalVolumeIcon />
              </div>
              <div className='total-transfer-amount__content'>
                {new Intl.NumberFormat('en').format(
                  totalTransferAmount ?? 'N/A',
                )}
                <span className='sub-text'>&nbsp;TOTAL TRANSFER AMOUNT</span>
              </div>
            </div>
          </div>
        </div>

        <Table
          hasOrderColumn
          filters={[
            {
              name: 'Phone',
              key: 'userPhone',
              input: (s) => (
                <TableFilterInputText
                  {...s}
                  value={valuePhoneFilter}
                  onChange={(e) => {
                    setValuePhoneFilter(e?.searchString);
                    s.onChange(e);
                  }}
                />
              ),
              defaultValue: valuePhoneFilter,
            },
            // {
            //     name: "Display name",
            //     key: "name",
            //     input: (s) => (
            //         <TableFilterInputText
            //             {...s}
            //             value={valueDisplayNameFilter}
            //             onChange={(e) => {
            //                 setValueDisplayNameFilter(e?.name);
            //                 s.onChange(e);
            //             }}
            //         />
            //     ),
            //     defaultValue: valueDisplayNameFilter
            // },
            // {
            //     name: "Type",
            //     key: "status",
            //     input: (s) => (
            //         <TableFilterInputSelect
            //             {...s}
            //             options={AdminService.getListUserStatus()}
            //             value={valueTypeFilter}
            //             onChange={(e) => {
            //                 setValueTypeFilter(e?.status);
            //                 s.onChange(e);
            //                 setForceUpdateTable(state => !state);
            //             }}
            //             isClearable={true}
            //             isSearchable={false}
            //         />
            //     ),
            //     defaultValue: valueTypeFilter
            // },
            // {
            //     name: "Time",
            //     key: "time",
            //     input: (s) => (
            //         <TableFilterInputSelect
            //             {...s}
            //             options={optionsTimeFilter}
            //             value={valueTimeFilter}
            //             onChange={(e) => {
            //                 setValueTimeFilter(e?.time);
            //                 s.onChange(e);
            //                 setForceUpdateTable(state => !state);
            //             }}
            //             isClearable={true}
            //         />
            //     ),
            //     defaultValue: valueTimeFilter
            // },
            {
              name: 'Time',
              key: 'time',
              input: (s) => (
                <TableFilterRangeTimeInput
                  {...s}
                  fromKey='fromDate'
                  toKey='toDate'
                />
              ),
            },
          ]}
          structure={structure}
          fetchData={async (params) => {
            setParams(params);
            return AdminService.getTransferList({
              page: params.pageNumber,
              pageSize: params.limit,
              ...params,
            }).then((res) => {
              setTotalTransferAmount(res?.totalTransferAmount);
              setCurrentData(res);
              return res;
            });
          }}
          forceUpdateTable={forceUpdateTable}
        />
      </div>
    );
  }),
);

export default TransferList;
